import React, {useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {orgId, defaultErrorHandler} from '../../context/context';
import customFormsV2Client from '../../infrastructure/acerill/custom-forms-v2-client';
import Section from '../../libs/react-components-admin/section/section';
import CenteredSpinner from '../../libs/react-components-admin/spinners/centered-spinner';
import InfoBox from '../../libs/react-components-admin/box/info-box';
import WarningBox from '../../libs/react-components-admin/box/warning-box';

const RetentionWarnings = ({retentionInDays}) => {

  const formattedDurationInDays = () => {
    if (retentionInDays < 300) {
      return retentionInDays.toFixed(0) + ' days';
    } else {
      return Math.round(retentionInDays / 365.0).toFixed(0) + ' years';
    }
  };

  const withBox = content => {
    if (retentionInDays < 50) {
      return <WarningBox>{content}</WarningBox>;
    } else {
      return <InfoBox>{content}</InfoBox>;
    }
  };

  return withBox(<>
    <div>
      <span className="material-icons align-bottom">&#xE002;</span> Submissions are automatically deleted
      after {formattedDurationInDays()}
    </div>
    {retentionInDays < 300 &&
    <div>
      To increase this duration, see <a href={'/billing/plans?shop=' + encodeURIComponent(orgId)}>our plans</a>
    </div>
    }
  </>);
};

const FormsWithSubmissions = ({formsWithSubmissions, retentionInDays}) => {

  const navigate = useNavigate();

  const goToFormSubmissions = formId => {
    navigate(`/forms/${encodeURIComponent(formId)}/submissions?shop=${encodeURIComponent(orgId)}`);
  };

  if (formsWithSubmissions.length === 0) {
    return <div className="row justify-content-center">
      <div className="col-auto h4">No submission found</div>
      <div className="w-100"/>
      <div className="col-auto">Did you enable submission storage in any of your forms?</div>
    </div>;
  }
  return <>
    <div className="mb-4">
      <RetentionWarnings retentionInDays={retentionInDays}/>
    </div>
    <ul className="list-group">
      {formsWithSubmissions
        .sort((f1, f2) => (f1.form.name || '').localeCompare(f2.form.name || ''))
        .map(formWithSubmissions => <li key={formWithSubmissions.form.id} className="list-group-item">
            <div className="row align-items-center">
              <div className="col">
                {formWithSubmissions.form.name}
              </div>
              <div className="col-auto">
                <button type="button"
                        className="btn btn-sm btn-primary px-4"
                        onClick={() => goToFormSubmissions(formWithSubmissions.form.id)}>
                  Go to submissions
                </button>
              </div>
            </div>
          </li>
        )
      }
    </ul>
  </>;
};

const Submissions = () => {

  const [formsWithSubmissions, setFormsWithSubmissions] = useState();
  const [retentionInDays, setRetentionInDays] = useState();

  useEffect(() => {
    customFormsV2Client.findAllFormsWithSubmissions()
      .then(response => {
        setFormsWithSubmissions(response.formsWithSubmissions);
        setRetentionInDays(response.retentionInDays);
      })
      .catch(err => defaultErrorHandler(err));
  }, []);

  return <Section title="Submissions" noMargin={true}>
    <div className="text-muted mb-1">
      Submissions are only stored for forms
      <ul>
        <li>displayed on a standalone page</li>
        <li>having submission storage enabled (see form settings)</li>
      </ul>
    </div>
    <div className="row justify-content-center">
      <div className="col-12 col-md-8">
        {!formsWithSubmissions || !retentionInDays ?
          <CenteredSpinner/> :
          <FormsWithSubmissions formsWithSubmissions={formsWithSubmissions}
                                retentionInDays={retentionInDays}/>
        }
      </div>
    </div>
  </Section>;
};

export default Submissions;
